export default [
  {
    path: '/campaign/notification',
    name: 'notification',
    component: () => import('@/views/pages/notification/ListNotification.vue'),
    meta: {
      name: 'notification',
      routeDetail: 'notification-detail',
      resource: 'Campaign - Notification',
      action: 'manage',
    },
  },
  {
    path: '/campaign/blast-email',
    name: 'blast-email',
    component: () => import('@/views/pages/notification/ListBlastEmail.vue'),
    meta: {
      name: 'blast-email',
      routeDetail: 'notification-detail',
      resource: 'Campaign - Blast Email',
      action: 'manage',
    },
  },
  {
    path: '/notification/create',
    name: 'notification-create',
    component: () => import('@/views/pages/notification/AddNotif.vue'),
    meta: {
      name: 'notification-create',
      resource: 'Campaign - Notification',
      action: 'manage',
    },
  },
  {
    path: '/notification/create/:id',
    name: 'notification-detail',
    component: () => import('@/views/pages/notification/AddNotif.vue'),
    meta: {
      name: 'notification-detail',
      resource: 'Campaign - Notification',
      action: 'manage',
    },
  },
  {
    path: '/notification/create-blast',
    name: 'notification-create-blast',
    component: () => import('@/views/pages/notification/AddBlast.vue'),
    meta: {
      name: 'notification-create-blast',
      resource: 'Campaign - Notification',
      action: 'manage',
    },
  },
  {
    path: '/notification/detail/notif/:id',
    name: 'notification-detail',
    component: () => import('@/views/pages/notification/DetailNotif.vue'),
    meta: {
      name: 'notification-detail',
      resource: 'Campaign - Notification',
      action: 'manage',
    },
  },
  {
    path: '/notification/detail/blast/:id',
    name: 'blast-detail',
    component: () => import('@/views/pages/notification/DetailBlast.vue'),
    meta: {
      name: 'blast-detail',
      resource: 'Campaign - Notification',
      action: 'manage',
    },
  },
  {
    path: '/notification/create-blast/:id',
    name: 'create-blast-id',
    component: () => import('@/views/pages/notification/AddBlast.vue'),
    meta: {
      name: 'blast-detail',
      resource: 'Campaign - Notification',
      action: 'manage',
    },
  },
]
